<template>
  <div id="app" class="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    '$route' (to, from) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style>
  .app {
    width: 100%;
    height: 100%;
  }
  .app > div {
    width: 100%;
    min-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue